/**
 * Nickname first, legal name optional (BRIEF §5.2). `children.name` is still
 * the API field, but the parent only ever sees it called "Nickname". Every
 * place that labels or explains the two names reads its copy from here, so the
 * wording lives in one place.
 */
export const NICKNAME_LABEL = "Nickname *";
export const NICKNAME_DISPLAY_LABEL = "Nickname";
export const NICKNAME_HINT = "What caregivers call them";
export const NICKNAME_PLACEHOLDER = "e.g. Mimi";

export const LEGAL_NAME_LABEL = "Legal name (optional)";
export const LEGAL_NAME_DISPLAY_LABEL = "Legal name";
export const LEGAL_NAME_HINT =
  "Only needed if a caregiver may have to deal with a hospital or school. Hidden on care links unless you choose to share it.";
